import React from 'react'

export default function Left (props) {
  return (
    <svg {...props} viewBox="0 0 1024 1024"  p-id="7744" width={props.width || 200} height={props.height || 200}>
      <path d="M416.045568 512L748.538368 893.44a84.48 84.48 0 0 1-0.2048 108.2368 61.1328 61.1328 0 0 1-94.3104 0.2048L275.450368 567.7056A82.2272 82.2272 0 0 1 255.994368 512a82.2272 82.2272 0 0 1 19.456-55.6032L654.023168 22.1184a61.1328 61.1328 0 0 1 94.208 0.2048 84.48 84.48 0 0 1 0.3072 108.2368L416.045568 512z" p-id="7745" fill="#F5004D" />
    </svg>
  )
}